<template>
  <el-dialog title="Variationen" :visible="show" @close="$emit('close')">
    <div class="row">
      <div class="col-sm-12">
        <revenue-table
          :stock-rotations="variations"
          :loading="false"
          view-type="variation"
        />
        <br>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import RevenueTable from './revenue-table'

export default {
  components: { [Dialog.name]: Dialog, RevenueTable },
  props: ['show', 'variations']
}
</script>

<style>
</style>
